"use strict";
/**
 * @license
 * Copyright 2017 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { registerEventListener } from "#src/util/disposable.js";
import { hexEncode, hexDecode } from "#src/util/hex.js";
export function encodeStringAsDragType(s) {
  return hexEncode(new TextEncoder().encode(s));
}
export function decodeStringFromDragType(s) {
  return new TextDecoder().decode(hexDecode(s));
}
export function encodeDragType(prefix, parameters) {
  return prefix + encodeStringAsDragType(JSON.stringify(parameters));
}
export function decodeParametersFromDragType(dragType, prefix) {
  if (!dragType.startsWith(prefix)) {
    return void 0;
  }
  try {
    const jsonString = decodeStringFromDragType(
      dragType.substring(prefix.length)
    );
    return JSON.parse(jsonString);
  } catch {
    return void 0;
  }
}
export function encodeParametersAsDragType(prefix, parameters) {
  return prefix + encodeStringAsDragType(JSON.stringify(parameters));
}
export function decodeParametersFromDragTypeList(dragTypes, prefix) {
  for (const dragType of dragTypes) {
    const parameters = decodeParametersFromDragType(dragType, prefix);
    if (parameters !== void 0) {
      return { parameters, dragType };
    }
  }
  return void 0;
}
let savedDropEffect;
export function setDropEffect(event, dropEffect) {
  event.dataTransfer.dropEffect = dropEffect;
  savedDropEffect = dropEffect;
  return dropEffect;
}
export function getDropEffect() {
  return savedDropEffect;
}
export function preventDrag(element) {
  element.draggable = true;
  return registerEventListener(element, "dragstart", (event) => {
    event.stopPropagation();
    event.preventDefault();
  });
}
